import { render } from "./processadd.vue?vue&type=template&id=3efa763c&scoped=true"
import script from "./processadd.vue?vue&type=script&lang=js"
export * from "./processadd.vue?vue&type=script&lang=js"

import "./processadd.vue?vue&type=style&index=0&id=3efa763c&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efa763c"]])

export default __exports__